import ApplicationModel, { attr } from '../ApplicationModel';
import { type PdlcStepAttributes } from './generated/PdlcStepAttributes';
import { model } from '../modelBuilder';

interface PdlcStep extends PdlcStepAttributes {}

@model
class PdlcStep extends ApplicationModel {
  // Start auto-generated
  static typename: 'PdlcStep' = 'PdlcStep';
  get typename(): 'PdlcStep' {
    return 'PdlcStep';
  }

  static internalTypename: 'Pdlc::Step' = 'Pdlc::Step';
  get internalTypename(): 'Pdlc::Step' {
    return 'Pdlc::Step';
  }

  static inputType = 'PdlcStepAttributes!';

  static filterType = 'PdlcStepFilters';
  static filters = { id: '[ID!]', pdlcFrameworkId: 'ID' };

  static fields = {
    commentsCount: attr({ readable: true }),
    duration: attr({ writable: true, readable: true }),
    frequency: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ writable: true, readable: true }),
    path: attr({ readable: true }),
    pdlcFrameworkId: attr({ readable: true }),
    position: attr({ writable: true, readable: false }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    comments: attr.hasMany({ readable: true }),
    tasks: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default PdlcStep;
